import { UmrahTour } from 'shared/api/umrah/tours'

export const prepareImages = (tour?: UmrahTour | null) => {
  if (!tour?.logo?.length) return []

  return tour.logo.map((item, index) => ({
    id: item.id,
    image: item.logo,
    image_fullpath: item.logo,
    sort_index: index,
  }))
}
